import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_nuxtvuexlocalstorage_2fb3e53c from 'nuxt_plugin_nuxtvuexlocalstorage_2fb3e53c' // Source: ./nuxt-vuex-localstorage.js (mode: 'client')
import nuxt_plugin_axios_3af8b295 from 'nuxt_plugin_axios_3af8b295' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_1ff09846 from 'nuxt_plugin_pluginutils_1ff09846' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_c7a7a7de from 'nuxt_plugin_pluginrouting_c7a7a7de' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_28e5a0fe from 'nuxt_plugin_pluginmain_28e5a0fe' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_4959a71e from 'nuxt_plugin_nuxtuseragent_4959a71e' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_image_25ffaf90 from 'nuxt_plugin_image_25ffaf90' // Source: ./image.js (mode: 'all')
import nuxt_plugin_components_567e580a from 'nuxt_plugin_components_567e580a' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_infiniteloading_1d322877 from 'nuxt_plugin_infiniteloading_1d322877' // Source: ../plugins/infinite-loading (mode: 'client')
import nuxt_plugin_vuelazyload_06cdeea4 from 'nuxt_plugin_vuelazyload_06cdeea4' // Source: ../plugins/vue-lazy-load (mode: 'client')
import nuxt_plugin_toast_233078b3 from 'nuxt_plugin_toast_233078b3' // Source: ../plugins/toast (mode: 'client')
import nuxt_plugin_statistics_6b868617 from 'nuxt_plugin_statistics_6b868617' // Source: ../plugins/statistics (mode: 'client')
import nuxt_plugin_vueinfiniteloading_7913c7de from 'nuxt_plugin_vueinfiniteloading_7913c7de' // Source: ../plugins/vue-infinite-loading (mode: 'client')
import nuxt_plugin_swiper_076f49ea from 'nuxt_plugin_swiper_076f49ea' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_vuejsmodal_17db18a4 from 'nuxt_plugin_vuejsmodal_17db18a4' // Source: ../plugins/vue-js-modal.js (mode: 'client')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_storageinject_56f547d2 from 'nuxt_plugin_storageinject_56f547d2' // Source: ../plugins/storage-inject (mode: 'client')
import nuxt_plugin_vuescroll_1abdb05f from 'nuxt_plugin_vuescroll_1abdb05f' // Source: ../plugins/vuescroll (mode: 'client')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_tvfetch_38941d18 from 'nuxt_plugin_tvfetch_38941d18' // Source: ../plugins/tv-fetch.js (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_router_3f7e063d from 'nuxt_plugin_router_3f7e063d' // Source: ../plugins/router (mode: 'all')
import nuxt_plugin_RSAWeb_07405008 from 'nuxt_plugin_RSAWeb_07405008' // Source: ../plugins/RSAWeb (mode: 'client')
import nuxt_plugin_RSANode_3e748064 from 'nuxt_plugin_RSANode_3e748064' // Source: ../plugins/RSANode (mode: 'server')
import nuxt_plugin_bury_92702464 from 'nuxt_plugin_bury_92702464' // Source: ../plugins/bury (mode: 'client')
import nuxt_plugin_semantic_bf6c208c from 'nuxt_plugin_semantic_bf6c208c' // Source: ../plugins/semantic (mode: 'all')
import nuxt_plugin_serverBury_044c70b1 from 'nuxt_plugin_serverBury_044c70b1' // Source: ../plugins/serverBury (mode: 'server')
import nuxt_plugin_arms_927124ea from 'nuxt_plugin_arms_927124ea' // Source: ../plugins/arms (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    return {
      // title: 'config.SEO.title',
      title: this.$t('seo.title'),
      meta: [
      { charset: 'utf-8' },
      // { name: 'viewport', content: 'viewport-fit=cover' },
      {
        name: 'viewport',
        content: 'viewport-fit=cover, width=device-width,initial-scale=1.0, maximum-scale=5.0' },

      // { name: 'keywords', content: this.$t('seo.keywords') },
      // {
      //   hid: 'description',
      //   name: 'description',
      //   content: this.$t('seo.description')
      // },
      {
        name: 'google-site-verification',
        content: 'WNjnC4EID0EM63PIceP9mbwpVRuGhhWUZh55j6PZTec' },

      {
        name: 'og:title',
        content: this.$t('seo.title') },

      {
        name: 'og:description',
        content: this.$t('seo.description') },

      {
        name: 'og:title',
        content: this.$t('seo.title') },

      {
        name: 'og:image',
        content: this.$t('seo.ogImage') }],

      link: [
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }
      // {
      //   rel: 'stylesheet',
      //   type: 'text/css',
      //   href: '//at.alicdn.com/t/font_3008679_5ozmmw4dudl.css'
      // }
      ],
      script:
      process.env.NODE_ENV === 'development' ?
      [] :
      [
      {
        async: true,
        body: true,
        src: 'https://hm.baidu.com/hm.js?7794ac8e272363414faaf51f99d343f1' },

      // {
      //   async: true,
      //   src: 'https://v1.cnzz.com/z_stat.php?id=1280809409&web_id=1280809409'
      // },
      {
        async: true,
        body: true,
        src: 'https://www.googletagmanager.com/gtag/js?id=G-262WP6CVKR' },

      {
        body: true,
        // src: 'https://cdn.rr.tv/vue/2.6.11/vue.min.js'
        src: 'https://cdn.jsdelivr.net/npm/vue@2.6.11/dist/vue.min.js' },

      {
        body: true,
        // src: 'https://cdn.rr.tv/vue-router/3.1.3/vue-router.min.js'
        src: 'https://cdn.jsdelivr.net/npm/vue-router@3.1.3/dist/vue-router.min.js' }

      // {src: 'https://cdn.rr.tv/better-scroll/1.15.2/bscroll.min.js'},
      ]
      // script: [
      //   {src: 'https://cdn.rr.tv/vue/2.6.11/vue.min.js'},
      //   {src: 'https://cdn.rr.tv/vue-router/3.1.3/vue-router.js'},
      //   {src: 'https://unpkg.com/better-scroll/dist/bscroll.min.js'},
      // ]
    };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_nuxtvuexlocalstorage_2fb3e53c === 'function') {
    await nuxt_plugin_nuxtvuexlocalstorage_2fb3e53c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3af8b295 === 'function') {
    await nuxt_plugin_axios_3af8b295(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1ff09846 === 'function') {
    await nuxt_plugin_pluginutils_1ff09846(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_c7a7a7de === 'function') {
    await nuxt_plugin_pluginrouting_c7a7a7de(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_28e5a0fe === 'function') {
    await nuxt_plugin_pluginmain_28e5a0fe(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_4959a71e === 'function') {
    await nuxt_plugin_nuxtuseragent_4959a71e(app.context, inject)
  }

  if (typeof nuxt_plugin_image_25ffaf90 === 'function') {
    await nuxt_plugin_image_25ffaf90(app.context, inject)
  }

  if (typeof nuxt_plugin_components_567e580a === 'function') {
    await nuxt_plugin_components_567e580a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_1d322877 === 'function') {
    await nuxt_plugin_infiniteloading_1d322877(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_06cdeea4 === 'function') {
    await nuxt_plugin_vuelazyload_06cdeea4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_233078b3 === 'function') {
    await nuxt_plugin_toast_233078b3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_statistics_6b868617 === 'function') {
    await nuxt_plugin_statistics_6b868617(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfiniteloading_7913c7de === 'function') {
    await nuxt_plugin_vueinfiniteloading_7913c7de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_076f49ea === 'function') {
    await nuxt_plugin_swiper_076f49ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsmodal_17db18a4 === 'function') {
    await nuxt_plugin_vuejsmodal_17db18a4(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_storageinject_56f547d2 === 'function') {
    await nuxt_plugin_storageinject_56f547d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescroll_1abdb05f === 'function') {
    await nuxt_plugin_vuescroll_1abdb05f(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_tvfetch_38941d18 === 'function') {
    await nuxt_plugin_tvfetch_38941d18(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_router_3f7e063d === 'function') {
    await nuxt_plugin_router_3f7e063d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_RSAWeb_07405008 === 'function') {
    await nuxt_plugin_RSAWeb_07405008(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_RSANode_3e748064 === 'function') {
    await nuxt_plugin_RSANode_3e748064(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bury_92702464 === 'function') {
    await nuxt_plugin_bury_92702464(app.context, inject)
  }

  if (typeof nuxt_plugin_semantic_bf6c208c === 'function') {
    await nuxt_plugin_semantic_bf6c208c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_serverBury_044c70b1 === 'function') {
    await nuxt_plugin_serverBury_044c70b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_arms_927124ea === 'function') {
    await nuxt_plugin_arms_927124ea(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
